



















































































































import { Component, Vue } from "vue-property-decorator";
import Task from "@/components/Task.vue";
@Component({
  components: {
    Task
  }
})
export default class Mission extends Vue {
  private started = false;
  private expanded = false;

  public toggleContent(): void {
    this.expanded = !this.expanded;
  }
}
